import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=d8b4ee74&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=js&"
export * from "./Calls.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tables/table-basic.css?vue&type=style&index=0&id=d8b4ee74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b4ee74",
  null
  
)

export default component.exports